<tr
    (click)="onClick()"
    [class.selected]="ticket === selectedTicket"
    >
    <td>
        <div class="all">
            <div>
                <span class="ticket-date">{{ dateFormatted(ticket) }}</span>
            </div>
            <div class="top-row">
                <!-- a finger-sized target around the box (#173); a click on it
                     checks the box and does not open the ticket -->
                <label class="check-target" (click)="$event.stopPropagation()">
                    <input
                        class="check"
                        type="checkbox"
                        [checked]="isSelectedFlag"
                        (click)="onSelect($event)"
                        />
                </label>
                <span class="ticket-title">{{ ticket.title }}</span>
                <span
                    class="recurring-badge"
                    *ngIf="isRecurring"
                    [title]="'recurrence.details.badge' | translate">
                    <span class="material-icons-outlined">repeat</span>
                </span>
            </div>
            <div class="bottom-row">
                <!-- only what is set, as in the plain list: a ticket without a status
                     drew an empty pill, a dark stripe once pills were solid (#173) -->
                <dependent-choice
                    *ngIf="isValidChoice(ticket.statusId)"
                    class="sts"
                    [topic]="'status'"
                    [reduced]="TRUE"
                    [isTicketContext]="TRUE"
                    [showLabel]="TRUE"
                    [selectedId]="ticket.statusId"
                    [labelOnDemand]="statusLabelerByService"
                    ></dependent-choice>
                <dependent-choice
                    *ngIf="isValidChoice(ticket.departmentId)"
                    class="dep"
                    [topic]="'departments'"
                    [reduced]="TRUE"
                    [isTicketContext]="TRUE"
                    [showLabel]="TRUE"
                    [selectedId]="ticket.departmentId"
                    [choiceObserver]="departmentIdObserver"
                    [labelOnDemand]="departmentLabelerByService"
                    ></dependent-choice>
                <dependent-choice
                    *ngIf="isValidChoice(ticket.branchId)"
                    class="dc"
                    [topic]="'branches'"
                    [reduced]="TRUE"
                    [isTicketContext]="TRUE"
                    [showLabel]="TRUE"
                    [selectedId]="ticket.branchId"
                    [labelOnDemand]="branchLabelerByService"
                    ></dependent-choice>
                <div class="space">
                    <dependent-choice
                        *ngIf="isValidChoice(ticket.priorityId)"
                        class="prio"
                        [topic]="'priority'"
                        [reduced]="TRUE"
                        [isTicketContext]="TRUE"
                        [showLabel]="TRUE"
                        [selectedId]="ticket.priorityId"
                        [labelOnDemand]="priorityLabelerByService"
                        ></dependent-choice>
                </div>
            </div>
        </div>
    </td>
</tr>
